<template>
  <b-modal
    id="modal-confirm-user"
    no-close-on-backdrop
    centered
    hide-footer
    hide-header
    body-class="modal-confirm-user"
    content-class="modal-confirm-user"
  >
    <template #default>
      <b-container fluid>
        <b-row class="justify-content-center mt-2">
          <b-col cols="auto">
            <b-icon
              v-if="isConfirm"
              icon="check-circle-fill"
              style="color: #4dae89; width: 50px; height: 50px"
            ></b-icon>
            <b-icon
              v-else
              icon="x-circle-fill"
              style="color: #d85a4a; width: 50px; height: 50px"
            ></b-icon>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mt-3">
          <b-col cols="6">
            <p v-if="isConfirm" class="text1-modal-confirm-user confirm-user">
              Tem certeza que deseja adicionar?
            </p>
            <p v-else class="text1-modal-confirm-user cancel-user">
              Tem certeza que deseja cancelar?
            </p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-5 mt-3">
          <b-col cols="6">
            <p v-if="isConfirm" class="text2-modal-confirm-user">
              Após a confirmação você <br />
              poderá alterar esse item
            </p>
            <p v-else class="text2-modal-confirm-user">
              As alterações não serão salvas
            </p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-3">
          <b-col cols="auto">
            <button
              class="button-modal-confirm-user btn-one-confirm-user"
              @click="$bvModal.hide('modal-confirm-user')"
            >
              <span v-if="isConfirm">VOLTAR</span>
              <span v-else>NÃO</span>
            </button>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-2">
          <b-col cols="auto">
            <button
              v-if="isConfirm"
              class="button-modal-confirm-user btn-two confirm-user"
              type="button"
              @click="responseModal(true)"
            >
              CONFIRMAR
            </button>
            <button
              v-else
              class="button-modal-confirm-user btn-two cancel-user"
              type="button"
              @click="responseModal(false)"
            >
              SIM
            </button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
export default {
  methods: {
    responseModal(isConfirm) {
      this.$emit('responseModalConfirmUser', isConfirm);
    },
  },
  data() {
    return {
      isConfirm: true,
    };
  },
};
</script>

<style>
.modal-confirm-user {
  background-color: #e8e8e8;
  padding: 8px;
  border-radius: 12px;
  border: none;
}

.text1-modal-confirm-user,
.text2-modal-confirm-user,
.button-modal-confirm-user {
  font-family: 'Inter', sans-serif;
  font-style: normal;
}

.text1-modal-confirm-user,
.text2-modal-confirm-user {
  text-align: center;
}

.text1-modal-confirm-user {
  font-size: 24px;
  font-weight: 900;
}

.text1-modal-confirm-user.confirm-user {
  color: #4dae89;
}

.text1-modal-confirm-user.cancel-user {
  color: #d85a4a;
}

.text2-modal-confirm-user {
  font-weight: 300;
  font-size: 16px;
  color: black;
}

.button-modal-confirm-user {
  min-width: fit-content;
  width: 196px;
  height: 28px;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.35em;
  font-weight: 700;
  border-radius: 13px;
}

.button-modal-confirm-user:focus {
  outline: none;
}

.btn-one-confirm-user {
  color: #272727;
  border: 1px solid #272727;
  background-color: transparent;
}

.btn-two.confirm-user,
.btn-two.cancel-user {
  color: white;
  border: none;
}

.btn-two.confirm-user {
  background-color: #4dae89;
}

.btn-two.cancel-user {
  background-color: #d85a4a;
}
</style>
